import checkSelected from "./checkSelected";
import collapseFiltersBlocks from "./collapse";
import minMaxPrice from "./minMaxPrice";
import preFilter from "./preFilter";

const filters = ({filterSelector = `.js-filter`, IMask}) => {
  const filtersContainer = document.querySelector(`.js-filter-container`);

  if (filtersContainer) {
    const filterForm = filtersContainer.querySelector(filterSelector);

    checkSelected(filterForm);
    collapseFiltersBlocks(filtersContainer);
    preFilter({filterForm});
    minMaxPrice({filterForm, IMask});
  }
};

export default filters;
